export default {
  data() { 
    return {
      loading: false,
      serversErrors: false
    }
  },
  methods: {
    prevStep() {
      this.$store.commit(`${this.module}/PREV_STEP`)
    },
    scrollToInvalidField(formSelector) {
      let correction = (this.$device.desktop() ? 40 : 90),
        y = (window.cfs.offset(document.querySelector(`${formSelector} .invalid`)).top) - correction
      window.scrollTo({top: y, behavior: 'smooth'})
    },
    formIsInvalid(scope) {
      let fields = scope ? this.fields[`$${scope}`] : this.fields
      if (fields){
        let r = Object.keys(fields).some(key => {
          return fields[key].invalid
        })
        return r
      }else{
        return false
      }
    },
    success(){
      this.loading = false
    },
    fail(response) {
      this.serversErrors = response.success == false ? response.errors : response
      this.loading = false
    },
    formSubmittion(payload) {
      return new Promise((resolve, reject) => {
        let { scope, formSelector } = payload
        if (!this.loading){
          this.serversErrors = false
          this.$validator.validate(scope).then((isValid) => {
            if (isValid) {
              this.loading = true
              resolve({success: this.success, fail: this.fail})
            } else {
              this.scrollToInvalidField(formSelector)
              reject()
            }
          })
        }
      })
    },
  }
}
